import { FAB, NumberInput } from "@mm/metx-design-system";
import debounce from "lodash/debounce";
import React, { useMemo, useState } from "react";
import styles from "./Control.module.scss";
import type { OffsetControlsProps } from "./OffsetControlType";

export function OffsetControl({ offsetMinutes, onOffsetChange }: OffsetControlsProps) {
  const [totalMinutes, setTotalMinutes] = useState(offsetMinutes);

  const debouncedChangeHandler = useMemo(() => debounce(onOffsetChange, 400), [onOffsetChange]);

  const saveOffset = (newMinutes: number) => {
    setTotalMinutes(newMinutes);
    debouncedChangeHandler(newMinutes);
  };

  // Split into signed parts so e.g. -90 min is shown as -1 h / -30 min.
  const hours = Math.trunc(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  const handleClearOffset = () => saveOffset(0);

  return (
    <div className={styles["style-controls"]}>
      <NumberInput
        aria-label={"Offset hours"}
        value={hours}
        unit={"h"}
        max={9000}
        min={-9000}
        style={{ width: "180px" }}
        step={1}
        onChange={(value) => saveOffset((value ?? 0) * 60 + minutes)}
      />
      <NumberInput
        aria-label={"Offset minutes"}
        value={minutes}
        unit={"min"}
        max={60}
        min={-60}
        step={1}
        style={{ width: "180px" }}
        onChange={(value) => saveOffset(hours * 60 + (value ?? 0))}
      />
      <div>
        <FAB
          size="sm"
          variant="primary"
          aria-label={"Reset offset"}
          shape="circle"
          icon={<span className="material-icons">refresh</span>}
          data-testid={"clear-offset"}
          onClick={handleClearOffset}
        />
      </div>
    </div>
  );
}
